import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { Platform } from "ionic-angular/index";

/**
 * Generated class for the SourceItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 *
 * 1.在 <source-item></source-item> 的父元素中加入 class="source-list-checkable" 可将此组件变为可选组件，checkbox对应的变量为source.checked
 *
 * @param onCheckChanged Output类型，当source.checked 变化时emit(source.checked)
 */
@Component({
  selector: 'source-item',
  templateUrl: 'source-item.html'
})
export class SourceItemComponent {

  @Input() source;

  @Input() disable_border:boolean;
  @Input() disable_preview:boolean;
  @Input() is_loading_mp3_id;
  @Input() is_playing_mp3_id;
  @Output() onItemClick = new EventEmitter();
  @Output() onItemMp3Play = new EventEmitter();
  @Output() onCheckChanged = new EventEmitter();

  @ViewChild('video') video;

  check: boolean =false;

  width;
  constructor(
    public platform:Platform,
    ) {
    console.log('Hello SourceItemComponent Component');
    this.width = ((platform.width() - 10 ) / 2) - 5;
  }

  itemClicked(e,source){
    if(this.disable_preview){
      switch (this.source.real_type){
        case 2:
          this.onItemClick.emit(this.source.real_type);
          break;
        case 3:
          this.onItemClick.emit(this.source.real_type);
        case 4:
          this.onItemClick.emit(this.source.real_type);
        default:
          this.itemCheckClicked(e,source);
          break;
      }
    }
    else {
      this.onItemClick.emit(this.source.real_type);
    }

  }

  bigImgClicked(event, source){
    //如果点击的是视频，那就直接播放视频
    if(source.real_type == 3){
      this.video.nativeElement.play();
    }else if(source.real_type == 4){
      this.onItemMp3Play.emit(source);
    }
  }

  /**
   * checkbox clicked*/
  itemCheckClicked(event, source){
    event.stopPropagation();

    source.checked = !source.checked;
    this.onCheckChanged.emit(source.checked);
  }

}



// WEBPACK FOOTER //
// ./src/components/source-item/source-item.ts